<template>
  <SalesPage />
</template>

<script>
// @ is an alias to /src
import SalesPage from "@/components/Shared/SalesPage/SalesPage.vue";

export default {
  name: "Supplier",
  components: {
    SalesPage
  }
};
</script>
